import React, { Component } from "react";
import moment from 'moment';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import Joi from "joi-browser";
import {AgentService } from "../services";
import httpClient from "../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import RatesTable from './ratesTable'

class DeleteProductRates extends Component {
  constructor(props) {
    super(props);
  
    
  }

  state = {
  
  };

  //schema

  componentDidMount() {
   


    

  }
 
  deletedata = async props => {
    try {
        let { status } = await httpClient.delete(`/products/product-rates/${this.props.rateId}`);
      
      if(status==200){
        this.props.history.push("/dashboard/Rates")
        this.props.toggle()
        
        this.props.data=this.props.data.filter(i=>i.rate_id!=this.props.rateId)
      

      }
      } catch (error) {
       
      }
  }

  render() {

  
    return (
   
     <div>
   
        <Modal isOpen={this.props.modal} toggle={this.props.toggle}  size={"lg"}>
          <ModalHeader
            className="bg-info text-light"
            toggle={this.props.toggle}
          >
           Delete Product Rate
          </ModalHeader>
          <ModalBody>
        <Label className="text-center" >Are You Want To Delete</Label>
          </ModalBody>
          <ModalFooter>
            <Button color="info" onClick={this.deletedata}>
            Delete
            </Button>{" "}
            <Button color="danger" onClick={this.props.toggle}>
            Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default DeleteProductRates;
